import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import styles from "./index.module.css";

/*
 * Item displaying information for the report table
 */
export default function ReportItemQualifyingGroup({
  item,
  isOdd,
  type,
  allColumns = [],
}) {
  // same width scaling as header: pivot columns get fixed percent each, other fixed columns
  // fill the remaining area proportionally
  const fixedBase = {
    ibo: 6,
    lastName: 8,
    displayName: 13,
    pin: 6,
    hpin: 10,
    email: 15,
    topicsId: 5,
    diamond: 8,
    users: 5,
  };
  const baseSum = Object.values(fixedBase).reduce((a, b) => a + b, 0);
  const pivotPer = 5;
  const pivotCount = allColumns.length;
  const pivotTotal = pivotPer * pivotCount;
  const remainingPct = Math.max(100 - pivotTotal, 0);
  const scaledWidths = Object.fromEntries(
    Object.entries(fixedBase).map(([k, v]) => [k, (v / baseSum) * remainingPct])
  );

  return (
    <div className={classNames(styles.iboItem, isOdd && styles.odd)}>
      <div
        className={styles.ibo}
        style={{
          fontWeight: type === "total" ? "bold" : "normal",
          width: `${scaledWidths.ibo}%`,
        }}
      >
        {item.IBO}
      </div>

      <div
        className={styles.lastName}
        style={{ width: `${scaledWidths.lastName}%` }}
      >
        {item.lastName}
      </div>
      <div
        className={styles.displayName}
        style={{ width: `${scaledWidths.displayName}%` }}
      >
        {item.displayName}
      </div>
      <div className={styles.pin} style={{ width: `${scaledWidths.pin}%` }}>
        {item.pin}
      </div>
      <div className={styles.hpin} style={{ width: `${scaledWidths.hpin}%` }}>
        {item.hpin}
      </div>
      <div className={styles.email} style={{ width: `${scaledWidths.email}%` }}>
        {item.email}
      </div>
      <div
        className={styles.topicsId}
        style={{ width: `${scaledWidths.topicsId}%` }}
      >
        {item.topicsId}
      </div>
      <div
        className={styles.diamond}
        style={{ width: `${scaledWidths.diamond}%` }}
      >
        {item.diamond}
      </div>
      <div
        className={
          type == "total"
            ? styles.totalUsers
            : item.isOverride
            ? styles.overrideUsers
            : styles.users
        }
        style={{
          fontWeight: type === "total" ? "bold" : "normal",
          width: `${scaledWidths.users}%`,
        }}
      >
        {item.users}
      </div>

      {allColumns.map((col, index, arr) => {
        // pivot columns each get pivotPer percent
        const colWidth = pivotPer;

        // find matching column in this row
        const match = item.columns.find((c) => c.name === col.name);
        const value = match ? match.value : "";
        const isWholeNumber = Number.isInteger(col.sort);

        return (
          <div
            key={`${col.name}-${value}-${index}`}
            className={index % 2 !== 0 ? styles.col : styles.oddCol}
            style={{
              width: `${colWidth}%`,
              fontWeight: isWholeNumber ? "bold" : "normal",
              borderLeft: isWholeNumber ? "1px solid #000" : "none",
              justifyContent: isWholeNumber ? "center" : "left",
            }}
          >
            {value}
          </div>
        );
      })}
    </div>
  );
}

ReportItemQualifyingGroup.propTypes = {
  item: PropTypes.object,
  isOdd: PropTypes.bool,
  type: PropTypes.string,
};
